import { render, staticRenderFns } from "./readClassify.vue?vue&type=template&id=e9052bee&scoped=true&"
import script from "./readClassify.vue?vue&type=script&lang=js&"
export * from "./readClassify.vue?vue&type=script&lang=js&"
import style0 from "./readClassify.vue?vue&type=style&index=0&id=e9052bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9052bee",
  null
  
)

export default component.exports